/* eslint-disable */
import React from "react";
import {
  DatetimeRenderers,
  DTPicker
} from "./Base";
import {
  setClientDateFormat,
  setServerDateFormat,
  setClientDateTimeFormat,
  setYearMonthWeekFormat,
  setClientDateFormatFromYearMonthWeek,
  setEndOfClientDateFormatFromYearMonthWeek,
  dateFormat,
  timeFormat
} from "../utility";
import * as Datetime from "react-datetime";
import Select from "react-select";

const onFilterChange = (props, newValue) => {
  let result = props.value.slice();
  result[props.index] = Object.assign({}, props.item, {
    value: newValue
  });
  return props.update(result);
};

// const onOptionsChange = (props, newValue) => {
//   let result = props.value.slice();
//   result[props.index] = Object.assign({}, props.item, {
//     options: newValue
//   });
//   return props.update(result);
// };

export const WeekOfMonth = props => (
  <div title={props.item.name} style={{ display: "flex" }}>
    <Datetime
      locale={"tr"}
      utc={true}
      renderDay={DatetimeRenderers.renderDay}
      timeFormat={false}
      dateFormat={dateFormat}
      closeOnSelect={true}
      value={setClientDateFormatFromYearMonthWeek(props.item.value)}
      onChange={result => onFilterChange(props, setYearMonthWeekFormat(result))}
    />
    <label
      style={{
        fontSize: "14px",
        margin: "auto",
        marginLeft: "5px"
      }}
    >
      {props.item.value
        ? "-" + setEndOfClientDateFormatFromYearMonthWeek(props.item.value)
        : ""}
    </label>
  </div>
);

export const DateTimeInterval = props => (
  <div title={props.item.name} style={{ display: "flex" }}>
    <DTPicker
      utc={true}
      timeFormat={timeFormat}
      dateFormat={dateFormat}
      closeOnSelect={true}
      value={setClientDateTimeFormat(props.item.value[0])}
      isValidDate={result =>
        props.item.value[1] ? result.isSameOrBefore(props.item.value[1]) : true
      }
      onChange={result =>
        onFilterChange(props, [
          setServerDateFormat(result),
          props.item.value[1]
        ])
      }
    />
    <DTPicker
      utc={true}
      timeFormat={timeFormat}
      dateFormat={dateFormat}
      closeOnSelect={true}
      value={setClientDateTimeFormat(props.item.value[1])}
      isValidDate={result =>
        props.item.value[0] ? result.isSameOrAfter(props.item.value[0]) : true
      }
      onChange={result =>
        onFilterChange(props, [
          props.item.value[0],
          setServerDateFormat(result)
        ])
      }
    />
  </div>
);


export const DateInterval = props => (
  <div title={props.item.name} style={{ display: "flex" }}>
    <DTPicker
      utc={true}
      dateFormat={dateFormat}
      closeOnSelect={true}
      value={setClientDateFormat(props.item.value[0])}
      isValidDate={result =>
        props.item.value[1] ? result.isSameOrBefore(props.item.value[1]) : true
      }
      onChange={result =>
        onFilterChange(props, [
          setServerDateFormat(result),
          props.item.value[1]
        ])
      }
    />
    <DTPicker
      utc={true}
      dateFormat={dateFormat}
      closeOnSelect={true}
      value={setClientDateFormat(props.item.value[1])}
      isValidDate={result =>
        props.item.value[0] ? result.isSameOrAfter(props.item.value[0]) : true
      }
      onChange={result =>
        onFilterChange(props, [
          props.item.value[0],
          setServerDateFormat(result)
        ])
      }
    />
  </div>
);

export class SelectItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      value: props.item.id,
      loading: false,
      pageSize: 50,
      page: 0,
      sorted: [],
      filtered: [],
      filteredAdd: [],
      pages: undefined
    };
  }
  componentDidMount() {
    if (
      this.props.item.type === "SelectQuery" ||
      this.props.item.type === "MultiSelectQuery"
    ) {
      // console.log("this.props.item.value\n", this.props.item.value);
      this.setState({ loading: true });
      this.props.task_request({
        action: "ReportListSelect",
        payload: {
          type: "get",
          id: this.props.item.query,
          pageSize: this.state.pageSize,
          page: this.state.page,
          sorted: this.state.sorted,
          filtered: this.state.filtered,
          filteredAdd: [
            {
              op: "parametric",
              id: "$1",
              value: this.props.item.value
            }
          ],
          parent: this.state.parent
          // values: ["%" + val + "%"]
        },
        success: result => {
          // console.log("result\n", result);
          this.setState({ options: result.rows, loading: false });
          let value =
            result.rows && result.rows[0] ? result.rows[0].value : undefined;
          onFilterChange(this.props, value);
          return this.props.noop({});
        }
      });
    } else {
      this.setState({ options: this.props.item.options });
    }
  }
  render() {
    return (
      <div title={this.props.item.name} style={{ display: "flex" }}>
        <Select
          autosize={false}
          multi={
            this.props.item.type === "MultiSelectList" ||
              this.props.item.type === "MultiSelectQuery"
              ? true
              : false
          }
          value={this.props.item.value}
          options={this.state.options}
          onChange={result => {
            let value = null;
            if (result) {
              value = Array.isArray(result)
                ? result.map(item => item.value)
                : result.value;
            }
            onFilterChange(this.props, value);
            return this.props.noop({});
          }}
          onInputChange={
            this.props.item.type === "SelectQuery" ||
              this.props.item.type === "MultiSelectQuery"
              ? val => {
                if (!val) return;
                return this.props.task_request({
                  action: "ReportListSelect",
                  payload: {
                    type: "set",
                    id: this.props.item.query,
                    pageSize: this.state.pageSize,
                    page: this.state.page,
                    sorted: this.state.sorted,
                    filtered: this.state.filtered,
                    filteredAdd: [
                      {
                        op: "parametric",
                        id: "$1",
                        value: `%${val}%`
                      }
                    ],
                    parent: this.state.parent
                  },
                  success: result => {
                    this.setState({ options: result.rows, loading: false });
                    return this.props.noop({});
                  }
                });
              }
              : undefined
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TableFilters.js